import { PHOTOS } from "@/lib/photos";

export interface BlogPost {
  slug: string;
  title: string;
  category: string;
  readTime: string;
  image: string;
  metaTitle: string;
  metaDescription: string;
  keywords: string[];
  author: string;
  datePublished: string;
  dateModified: string;
}

export const BLOG_POSTS: BlogPost[] = [
  {
    slug: "what-is-yacht-rock",
    title: "What is Yacht Rock? The Genre That Defined a Generation",
    category: "Culture",
    readTime: "5 min read",
    image: PHOTOS.STAGE.pianistSparkle,
    metaTitle: "What Is Yacht Rock? History, Artists & Songs",
    metaDescription: "Discover what yacht rock is, the artists who defined it, and why this smooth 70s and 80s genre is making a comeback. From Steely Dan to Toto — the full story.",
    keywords: ["what is yacht rock", "yacht rock genre", "yacht rock music", "soft rock 70s 80s", "smooth rock music"],
    author: "Yacht Rock Detroit",
    datePublished: "2026-01-15",
    dateModified: "2026-02-12",
  },
  {
    slug: "the-ultimate-yacht-rock-playlist",
    title: "The Ultimate Yacht Rock Playlist: 50 Songs That Sound Like Summer",
    category: "Music",
    readTime: "6 min read",
    image: PHOTOS.DJ.djKeo,
    metaTitle: "Ultimate Yacht Rock Playlist — 50 Songs",
    metaDescription: "The definitive yacht rock playlist with 50 essential songs from Toto, Steely Dan, Christopher Cross, Hall & Oates, and more. Build your perfect summer soundtrack.",
    keywords: ["yacht rock playlist", "best yacht rock songs", "yacht rock songs list", "classic yacht rock hits", "smooth rock playlist"],
    author: "Yacht Rock Detroit",
    datePublished: "2026-01-20",
    dateModified: "2026-02-12",
  },
  {
    slug: "best-summer-concerts-in-2026",
    title: "Best Summer Concerts in Detroit for 2026: The Complete Guide",
    category: "Events",
    readTime: "5 min read",
    image: PHOTOS.STAGE.bandLargeOutdoor,
    metaTitle: "Best Summer Concerts in Detroit 2026",
    metaDescription: "The complete guide to Detroit's best summer concerts in 2026. From Yacht Rock Detroit to Bruno Mars, Movement, Foo Fighters, and more — ranked and reviewed.",
    keywords: ["best summer concerts Detroit 2026", "Detroit concerts summer 2026", "live music Detroit", "outdoor concerts Detroit"],
    author: "Yacht Rock Detroit",
    datePublished: "2026-02-01",
    dateModified: "2026-02-12",
  },
  {
    slug: "your-first-time-at-yacht-rock-detroit",
    title: "Your First Time at Yacht Rock Detroit: Everything You Need to Know",
    category: "Guide",
    readTime: "7 min read",
    image: PHOTOS.DANCING.crowdHandsUpCaptainHats,
    metaTitle: "First Time at Yacht Rock Detroit — What to Know",
    metaDescription: "Planning your first visit to Yacht Rock Detroit 2026? Everything you need: venue details, VIP info, what to wear, food & drinks, parking, and what to expect.",
    keywords: ["Yacht Rock Detroit", "yacht rock concert Detroit", "Yacht Rock Detroit 2026", "The Roostertail Detroit", "waterfront concerts Detroit"],
    author: "Yacht Rock Detroit",
    datePublished: "2026-02-05",
    dateModified: "2026-02-12",
  },
  {
    slug: "detroit-waterfront-events-2026",
    title: "Detroit Waterfront Events: Your 2026 Summer Guide",
    category: "Events",
    readTime: "5 min read",
    image: PHOTOS.VENUE.roostertailExteriorNight,
    metaTitle: "Detroit Waterfront Events — Summer 2026 Guide",
    metaDescription: "Your complete guide to Detroit waterfront events in summer 2026. Music festivals, riverfront parks, dining, and getting around — everything happening on the water.",
    keywords: ["Detroit waterfront events", "Detroit River events 2026", "things to do Detroit waterfront", "Detroit riverfront summer"],
    author: "Yacht Rock Detroit",
    datePublished: "2026-02-08",
    dateModified: "2026-02-12",
  },
  {
    slug: "15-yacht-rock-bands-you-need-to-know",
    title: "15 Yacht Rock Bands You Need to Know Before the Summer",
    category: "Music",
    readTime: "8 min read",
    image: PHOTOS.STAGE.fullBandCaptainHats,
    metaTitle: "15 Yacht Rock Bands You Need to Know",
    metaDescription: "Meet the 15 essential yacht rock bands from Toto to Steely Dan, Christopher Cross, Hall & Oates, and more. Essential tracks, bios, and why they still matter.",
    keywords: ["yacht rock bands", "best yacht rock artists", "yacht rock musicians", "70s 80s soft rock bands", "Christopher Cross", "Toto"],
    author: "Yacht Rock Detroit",
    datePublished: "2026-02-10",
    dateModified: "2026-02-12",
  },
];
